import { mockups } from '../../data/landingPage';
import DownloadButton from '../DownloadButton/DownloadButton';
import PhoneMockup from '../PhoneMockup/PhoneMockup';
import './FinalCta.css';

function FinalCta() {
  return (
    <section className="final-cta" id="download" aria-labelledby="download-title">
      <div>
        <h2 id="download-title">Come back to yourself in just a minute.</h2>
        <p>RELI is here for the moments when life feels like too much. You don't have to do it all alone.</p>
        <DownloadButton />
      </div>
      <div className="single-phone">
        <PhoneMockup src={mockups.starlight} alt="RELI feeling selection screen" tilt="tilt-left" />
      </div>
    </section>
  );
}

export default FinalCta;
